import { FC } from 'react';
import { Check } from 'lucide-react';

import { SkuSearchResponseOutputItemsItem } from '@/api/generated';
import { PackShot } from '@/components/blocks/shelf-detail/shelf-detail-sku/pack-shot';
import { Badge } from '@/components/ui/badge';
import { Card, CardContent, CardDescription } from '@/components/ui/card';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';

interface SkuOverviewCardProps {
  item: SkuSearchResponseOutputItemsItem;
  isConfirmed: boolean;
  onSelectSku: (skuMetadataId: string) => void;
  className?: string;
}

export const SkuOverviewCard: FC<SkuOverviewCardProps> = ({
  item,
  isConfirmed,
  onSelectSku,
  className,
}: SkuOverviewCardProps) => (
  <Tooltip>
    <TooltipTrigger asChild>
      {
        <Card
          role='button'
          className={cn(
            'items-center gap-2 hover:cursor-pointer hover:border-[#FF6738] overflow-hidden relative',
            { 'bg-accent': isConfirmed },
            className
          )}
          onClick={() => {
            onSelectSku(item.skuMetadataId);
          }}>
          <CardContent>
            <PackShot
              imagePath={item.imagePath}
              alt={item.skuName}
              className='size-full'
            />
          </CardContent>
          {isConfirmed && (
            <CardDescription
              className={
                'absolute inset-x-0 bottom-0 flex items-center justify-between h-1/5 bg-secondary/50'
              }>
              <Badge
                variant='annotated'
                aria-hidden>
                <Check className='text-success size-2' />
              </Badge>
            </CardDescription>
          )}
        </Card>
      }
    </TooltipTrigger>
    <TooltipContent>
      <span className='truncate text-sm text-white'>{item.skuName}</span>
    </TooltipContent>
  </Tooltip>
);
